import { render, staticRenderFns } from "./ArticleAutoCompleter.vue?vue&type=template&id=130a3f13&"
import script from "./ArticleAutoCompleter.vue?vue&type=script&lang=js&"
export * from "./ArticleAutoCompleter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports